"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFungibleToken = exports.deployFungibleToken = exports.deployZilswapV2Pool = exports.deployZilswapV2Router = exports.deployWrappedZIL = exports.deployContract = exports.callContract = exports.increaseAllowance = exports.setFeeConfig = exports.addPool = exports.getAmpBps = exports.getContractCodeHash = exports.getContract = exports.compress = exports.compile = exports.param = exports.zilliqa = exports.rpc = exports.network = exports.LONG_ALPHA = exports.SHORT_ALPHA = exports.PRECISION = void 0;
var core_1 = require("@zilliqa-js/core");
var zilliqa_1 = require("@zilliqa-js/zilliqa");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var crypto_1 = __importDefault(require("crypto"));
var dotenv = __importStar(require("dotenv"));
var fs = __importStar(require("fs"));
var util = __importStar(require("util"));
var constants_1 = require("../constants");
dotenv.config();
exports.PRECISION = 1000000000000000000;
exports.SHORT_ALPHA = 370301795963710;
exports.LONG_ALPHA = 185168039996296;
var getNetwork = function () {
    var net = (process.env.NETWORK || '').toLowerCase();
    switch (net) {
        case 'mainnet':
            return constants_1.Network.MainNet;
        case 'testnet':
            return constants_1.Network.TestNet;
        // case 'localhost':
        // return Network.LocalHost
        default:
            return constants_1.Network.TestNet;
    }
};
var getRPC = function (net) {
    return constants_1.APIS[net];
};
exports.network = getNetwork();
exports.rpc = getRPC(exports.network);
exports.zilliqa = new zilliqa_1.Zilliqa(exports.rpc);
var param = function (vname, type, value) {
    return { vname: vname, type: type, value: value };
};
exports.param = param;
var randomHex = function (size) { return __spreadArray([], Array(size), true).map(function () { return Math.floor(Math.random() * 16).toString(16); }).join(''); };
var matchComments = /[(][*].*?[*][)]/gs;
var compile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var readFile, code;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                readFile = util.promisify(fs.readFile);
                return [4 /*yield*/, readFile(file)];
            case 1:
                code = (_a.sent()).toString();
                return [2 /*return*/, (0, exports.compress)(code)];
        }
    });
}); };
exports.compile = compile;
var compress = function (code) {
    return code.replace(matchComments, '');
};
exports.compress = compress;
var getContract = function (address) {
    return exports.zilliqa.contracts.at(address);
};
exports.getContract = getContract;
var getContractCodeHash = function (file) {
    var code = fs.readFileSync(file).toString();
    var compressedCode = (0, exports.compress)(code);
    var buffer = Buffer.from(compressedCode);
    return "0x" + crypto_1.default.createHash("sha256").update(buffer).digest("hex");
};
exports.getContractCodeHash = getContractCodeHash;
var getAmpBps = function (isAmpPool) {
    var ampBps = isAmpPool ? "15000" : "10000";
    return ampBps;
};
exports.getAmpBps = getAmpBps;
function getBlockNum() {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(process.env.NETWORK === 'localhost')) return [3 /*break*/, 2];
                    return [4 /*yield*/, exports.zilliqa.provider.send('GetBlocknum', "")];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, exports.zilliqa.blockchain.getNumTxBlocks()];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    response = _a;
                    if (!response.result) {
                        throw new Error("Failed to get block! Error: ".concat(JSON.stringify(response.error)));
                    }
                    return [2 /*return*/, parseInt(response.result, 10)];
            }
        });
    });
}
// async function nextBlock(n = 1) {
//   if (process.env.NETWORK === 'localhost') {
//     // console.log('Advancing block...')
//     const response = await zilliqa.provider.send('IncreaseBlocknum', n)
//     if (!response.result) {
//       throw new Error(`Failed to advanced block! Error: ${JSON.stringify(response.error)}`)
//     }
//   }
// }
function useKey(privateKey) {
    var address = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey);
    var accounts = Object.keys(exports.zilliqa.wallet.accounts);
    if (accounts.findIndex(function (a) { return a.toLowerCase() === address.toLowerCase(); }) < 0) {
        exports.zilliqa.wallet.addByPrivateKey(privateKey);
    }
    exports.zilliqa.wallet.setDefault(address);
}
function addPool(privateKey, router, poolAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callContract(privateKey, router, 'AddPool', [
                        {
                            vname: 'pool',
                            type: 'ByStr20',
                            value: poolAddress,
                        },
                    ], 0, false, false)];
                case 1:
                    tx = _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.addPool = addPool;
function setFeeConfig(privateKey, router, feeAddress) {
    return __awaiter(this, void 0, void 0, function () {
        var tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callContract(privateKey, router, 'SetFeeConfiguration', [
                        {
                            vname: 'config',
                            type: 'Pair ByStr20 Uint128',
                            value: {
                                "constructor": "Pair",
                                "argtypes": ["ByStr20", "Uint128"],
                                "arguments": ["".concat(feeAddress), "1000"] // 10%
                            }
                        },
                    ], 0, false, false)];
                case 1:
                    tx = _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.setFeeConfig = setFeeConfig;
function increaseAllowance(privateKey, contract, spender) {
    return __awaiter(this, void 0, void 0, function () {
        var tx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callContract(privateKey, contract, 'IncreaseAllowance', [
                        {
                            vname: 'spender',
                            type: 'ByStr20',
                            value: spender, // contract hash
                        },
                        {
                            vname: 'amount',
                            type: 'Uint128',
                            value: '100000000000000000000000000000000000000',
                        },
                    ], 0, false, false)];
                case 1:
                    tx = _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.increaseAllowance = increaseAllowance;
function callContract(privateKey, contract, transition, args, zilsToSend, insertRecipientAsSender, insertDeadlineBlock) {
    if (zilsToSend === void 0) { zilsToSend = 0; }
    if (insertRecipientAsSender === void 0) { insertRecipientAsSender = true; }
    if (insertDeadlineBlock === void 0) { insertDeadlineBlock = true; }
    return __awaiter(this, void 0, void 0, function () {
        var address, deadline, minGasPrice, tx, receipt, errors_1, errMsgs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    useKey(privateKey);
                    address = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey);
                    if (!insertDeadlineBlock) return [3 /*break*/, 2];
                    return [4 /*yield*/, getBlockNum()];
                case 1:
                    deadline = (_a.sent()) + 10;
                    args.push({
                        vname: 'deadline_block',
                        type: 'BNum',
                        value: deadline.toString(),
                    });
                    _a.label = 2;
                case 2:
                    if (insertRecipientAsSender) {
                        args.push({
                            vname: 'recipient_address',
                            type: 'ByStr20',
                            value: address,
                        });
                    }
                    return [4 /*yield*/, exports.zilliqa.blockchain.getMinimumGasPrice()];
                case 3:
                    minGasPrice = _a.sent();
                    console.info("Calling: ".concat(transition));
                    return [4 /*yield*/, contract.call(transition, args, {
                            version: constants_1.CHAIN_VERSIONS[exports.network],
                            amount: zilliqa_1.units.toQa(zilsToSend, zilliqa_1.units.Units.Zil),
                            gasPrice: new zilliqa_1.BN(minGasPrice.result),
                            gasLimit: zilliqa_1.Long.fromNumber(80000),
                        }, 33, 1000, true)];
                case 4:
                    tx = _a.sent();
                    receipt = tx.getReceipt();
                    if (receipt && !receipt.success) {
                        errors_1 = receipt.errors;
                        if (errors_1) {
                            errMsgs = Object.keys(errors_1).reduce(function (acc, depth) {
                                var _a;
                                var errorMsgList = errors_1[depth].map(function (num) { return core_1.TransactionError[num]; });
                                return __assign(__assign({}, acc), (_a = {}, _a[depth] = errorMsgList, _a));
                            }, {});
                            console.info("Contract call for ".concat(transition, " failed:\n").concat(JSON.stringify(errMsgs, null, 2), "\n") +
                                "".concat(receipt.exceptions ? "Exceptions:\n".concat(JSON.stringify(receipt.exceptions, null, 2), "\n") : '') +
                                "Parameters:\n".concat(JSON.stringify(args), "\n"));
                        }
                    }
                    // await nextBlock()
                    return [2 /*return*/, tx];
            }
        });
    });
}
exports.callContract = callContract;
function deployContract(privateKey, file, init) {
    return __awaiter(this, void 0, void 0, function () {
        var address, balance, minGasPrice, compressedCode, contract, _a, deployTx, s, confirmedTx, errors_2, errMsgs, error, deployedContract, state;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Check for key
                    if (privateKey === '') {
                        throw new Error('No private key was provided!');
                    }
                    useKey(privateKey);
                    address = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey);
                    return [4 /*yield*/, exports.zilliqa.blockchain.getBalance(address)];
                case 1:
                    balance = _b.sent();
                    if (balance.error) {
                        throw new Error(balance.error.message);
                    }
                    return [4 /*yield*/, exports.zilliqa.blockchain.getMinimumGasPrice()
                        // console.log("minGasPrice", minGasPrice)
                        // Deploy contract
                    ];
                case 2:
                    minGasPrice = _b.sent();
                    return [4 /*yield*/, (0, exports.compile)(file)];
                case 3:
                    compressedCode = _b.sent();
                    contract = exports.zilliqa.contracts.new(compressedCode, init);
                    return [4 /*yield*/, contract.deployWithoutConfirm({
                            version: constants_1.CHAIN_VERSIONS[exports.network],
                            gasPrice: new zilliqa_1.BN(minGasPrice.result),
                            gasLimit: zilliqa_1.Long.fromNumber(80000),
                        }, false)
                        // Check for txn acceptance
                    ];
                case 4:
                    _a = _b.sent(), deployTx = _a[0], s = _a[1];
                    // Check for txn acceptance
                    if (!deployTx.id) {
                        throw new Error(JSON.stringify(s.error || 'Failed to get tx id!', null, 2));
                    }
                    console.info("Deployment transaction id: ".concat(deployTx.id));
                    return [4 /*yield*/, deployTx.confirm(deployTx.id, 33, 1000)];
                case 5:
                    confirmedTx = _b.sent();
                    // Check for txn execution success
                    if (!confirmedTx.txParams.receipt.success) {
                        errors_2 = confirmedTx.txParams.receipt.errors || {};
                        errMsgs = JSON.stringify(Object.keys(errors_2).reduce(function (acc, depth) {
                            var _a;
                            var errorMsgList = errors_2[depth].map(function (num) { return core_1.TransactionError[num]; });
                            return __assign(__assign({}, acc), (_a = {}, _a[depth] = errorMsgList, _a));
                        }, {}));
                        error = "Failed to deploy contract at ".concat(file, "!\n").concat(errMsgs);
                        throw new Error(error);
                    }
                    // Print txn receipt
                    console.log("Deployment transaction receipt:\n".concat(JSON.stringify(confirmedTx.txParams.receipt)));
                    // await nextBlock()
                    // Refetch contract
                    console.info("The contract address is: ".concat(s.address));
                    deployedContract = exports.zilliqa.contracts.at(s.address);
                    return [4 /*yield*/, deployedContract.getState()
                        // Print contract state
                    ];
                case 6:
                    state = _b.sent();
                    // Print contract state
                    console.log("The state of the contract is:\n".concat(JSON.stringify(state, null, 2)));
                    // Return the contract and state
                    return [2 /*return*/, [deployedContract, state]];
            }
        });
    });
}
exports.deployContract = deployContract;
function deployWrappedZIL(privateKey, _a) {
    var _b = _a.name, name = _b === void 0 ? 'WZIL Token' : _b, _c = _a.symbol, symbol = _c === void 0 ? 'WZIL' : _c, _d = _a.decimals, decimals = _d === void 0 ? 12 : _d, _e = _a.initSupply, initSupply = _e === void 0 ? '1000000000000000000000' : _e;
    return __awaiter(this, void 0, void 0, function () {
        var address, file, init;
        return __generator(this, function (_f) {
            // Check for key
            if (privateKey === '') {
                throw new Error('No private key was provided!');
            }
            address = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey);
            file = './src/zilswap-v2/contracts/WrappedZil.scilla';
            init = [
                // this parameter is mandatory for all init arrays
                {
                    vname: '_scilla_version',
                    type: 'Uint32',
                    value: '0',
                },
                {
                    vname: 'name',
                    type: 'String',
                    value: "".concat(name),
                },
                {
                    vname: 'symbol',
                    type: 'String',
                    value: "".concat(symbol),
                },
                {
                    vname: 'decimals',
                    type: 'Uint32',
                    value: "".concat(decimals),
                },
                {
                    vname: 'init_supply',
                    type: 'Uint128',
                    value: "".concat(initSupply),
                },
                {
                    vname: 'contract_owner',
                    type: 'ByStr20',
                    value: "".concat(address),
                },
            ];
            console.info("Deploying Wrapped Zil Token...");
            return [2 /*return*/, deployContract(privateKey, file, init)];
        });
    });
}
exports.deployWrappedZIL = deployWrappedZIL;
function deployZilswapV2Router(privateKey, _a) {
    var governor = _a.governor, codehash = _a.codehash, wZil = _a.wZil;
    return __awaiter(this, void 0, void 0, function () {
        var file, init;
        return __generator(this, function (_b) {
            // Check for key
            if (privateKey === '') {
                throw new Error('No private key was provided!');
            }
            // Default vars
            if (!governor)
                governor = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey).toLowerCase();
            file = "./src/zilswap-v2/contracts/ZilSwapRouter.scilla";
            init = [
                // this parameter is mandatory for all init arrays
                {
                    vname: '_scilla_version',
                    type: 'Uint32',
                    value: '0',
                },
                {
                    vname: 'init_governor',
                    type: 'ByStr20',
                    value: governor,
                },
                {
                    vname: 'init_codehash',
                    type: 'ByStr32',
                    value: codehash,
                },
                {
                    vname: 'init_wZIL_address',
                    type: 'ByStr20',
                    value: wZil,
                }
            ];
            console.log(init);
            console.info("Deploying zilswap-v2 router...");
            return [2 /*return*/, deployContract(privateKey, file, init)];
        });
    });
}
exports.deployZilswapV2Router = deployZilswapV2Router;
function deployZilswapV2Pool(privateKey, _a) {
    var router = _a.router, token0 = _a.token0, token1 = _a.token1, init_amp_bps = _a.init_amp_bps, name = _a.name, symbol = _a.symbol;
    return __awaiter(this, void 0, void 0, function () {
        var t0State, t1State, pair, file, init;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Check for key
                    if (privateKey === '') {
                        throw new Error('No private key was provided!');
                    }
                    if (!(!name || !symbol)) return [3 /*break*/, 3];
                    return [4 /*yield*/, token0.getInit()];
                case 1:
                    t0State = _b.sent();
                    return [4 /*yield*/, token1.getInit()];
                case 2:
                    t1State = _b.sent();
                    pair = "".concat(t0State.find(function (i) { return i.vname === 'symbol'; }).value, "-").concat(t1State.find(function (i) { return i.vname === 'symbol'; }).value);
                    if (!name)
                        name = "ZilSwap V2 ".concat(pair, " LP Token");
                    if (!symbol)
                        symbol = "ZWAPv2LP.".concat(pair);
                    _b.label = 3;
                case 3:
                    file = "./src/zilswap-v2/contracts/ZilSwapPool.scilla";
                    init = [
                        // this parameter is mandatory for all init arrays
                        {
                            vname: '_scilla_version',
                            type: 'Uint32',
                            value: '0',
                        },
                        {
                            vname: 'init_token0',
                            type: 'ByStr20',
                            value: token0.address.toLowerCase(),
                        },
                        {
                            vname: 'init_token1',
                            type: 'ByStr20',
                            value: token1.address.toLowerCase(),
                        },
                        {
                            vname: 'init_factory',
                            type: 'ByStr20',
                            value: router.address.toLowerCase(),
                        },
                        {
                            vname: 'init_amp_bps',
                            type: 'Uint128',
                            value: init_amp_bps.toString(),
                        },
                        {
                            vname: 'contract_owner',
                            type: 'ByStr20',
                            value: router.address.toLowerCase(),
                        },
                        {
                            vname: 'name',
                            type: 'String',
                            value: name,
                        },
                        {
                            vname: 'symbol',
                            type: 'String',
                            value: symbol,
                        },
                        {
                            vname: 'decimals',
                            type: 'Uint32',
                            value: '12',
                        },
                        {
                            vname: 'init_supply',
                            type: 'Uint128',
                            value: '0',
                        },
                    ];
                    console.log(init);
                    console.info("Deploying zilswap-v2 pool...");
                    return [2 /*return*/, deployContract(privateKey, file, init)];
            }
        });
    });
}
exports.deployZilswapV2Pool = deployZilswapV2Pool;
function deployFungibleToken(privateKey, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? 'ZS Test Token' : _c, _d = _b.symbol, _symbol = _d === void 0 ? null : _d, _e = _b.decimals, decimals = _e === void 0 ? 12 : _e, _f = _b.supply, supply = _f === void 0 ? new zilliqa_1.BN('100000000000000000000000000000000000000') : _f;
    return __awaiter(this, void 0, void 0, function () {
        var address, symbol, file, init;
        return __generator(this, function (_g) {
            // Check for key
            if (privateKey === '') {
                throw new Error('No private key was provided!');
            }
            address = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey);
            symbol = _symbol || "TEST-".concat(randomHex(4).toUpperCase());
            file = "./src/zilswap-v2/contracts/FungibleToken.scilla";
            init = [
                // this parameter is mandatory for all init arrays
                {
                    vname: '_scilla_version',
                    type: 'Uint32',
                    value: '0',
                },
                {
                    vname: 'contract_owner',
                    type: 'ByStr20',
                    value: "".concat(address),
                },
                {
                    vname: 'name',
                    type: 'String',
                    value: "".concat(name),
                },
                {
                    vname: 'symbol',
                    type: 'String',
                    value: "".concat(symbol),
                },
                {
                    vname: 'decimals',
                    type: 'Uint32',
                    value: decimals.toString(),
                },
                {
                    vname: 'init_supply',
                    type: 'Uint128',
                    value: supply.toString(),
                }
            ];
            console.info("Deploying fungible token ".concat(symbol, "..."));
            return [2 /*return*/, deployContract(privateKey, file, init)];
        });
    });
}
exports.deployFungibleToken = deployFungibleToken;
function useFungibleToken(privateKey, params, approveContractAddress) {
    if (approveContractAddress === void 0) { approveContractAddress = null; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, contract, state, address, allowance, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, deployFungibleToken(privateKey, params)];
                case 1:
                    _a = _c.sent(), contract = _a[0], state = _a[1];
                    if (!!!approveContractAddress) return [3 /*break*/, 4];
                    address = (0, zilliqa_1.getAddressFromPrivateKey)(privateKey).toLowerCase();
                    allowance = new bignumber_js_1.default(state.allowances[address] ? state.allowances[address][approveContractAddress.toLowerCase()] : 0);
                    if (!(allowance.isNaN() || allowance.eq(0))) return [3 /*break*/, 4];
                    return [4 /*yield*/, callContract(privateKey, contract, 'IncreaseAllowance', [
                            {
                                vname: 'spender',
                                type: 'ByStr20',
                                value: approveContractAddress,
                            },
                            {
                                vname: 'amount',
                                type: 'Uint128',
                                value: state.total_supply.toString(),
                            },
                        ], 0, false, false)];
                case 2:
                    _c.sent();
                    _b = [contract];
                    return [4 /*yield*/, contract.getState()];
                case 3: return [2 /*return*/, _b.concat([_c.sent()])];
                case 4: return [2 /*return*/, [contract, state]];
            }
        });
    });
}
exports.useFungibleToken = useFungibleToken;
//# sourceMappingURL=utils.js.map